export const BRAND = {
  kenwood: "kenwood",
  delonghi: "delonghi",
  braun: "braun"
};

export const errorsMsg = {
  BOOLEAN_EXPECTED: "Test",
  GENERAL: "Error!",
  JSON: "Error: The required configuration doesn't exist",
  MISSING_TRANSLATION: "{missing_translation}",
};
export const type = {
  BOOLEAN: "boolean",
  RADIOGROUP: "radiogroup",
  CHECKBOX: "checkbox",
  IMAGEPICKER: "imagepicker",
};
export const node = {
  PAGES: "pages",
  ELEMENTS: "elements",
  NAME: "name",
  TITLE: "title",
  TYPE: "type",
  CHOICES: "choices",
  IMAGE: "imageLink",
  MULTISELECT: "multiSelect",
  MINSELECTEDCHOICES: "minSelectedChoices",
  MAXSELECTEDCHOICES: "maxSelectedChoices",
  VISIBLEIF: "visibleIf",
  ONCOMPLETED: {
    GOTOURL: "navigateToUrlOnCondition",
    SHOWPRODUCTS: "completedHtmlOnCondition",
    CATEGORYURL: "categoryUrl",
    CATEGORYIDENTIFIER: "categoryIdentifier",
    PRODUCTSLIST: "isProductsList",
    PRODUCTSTYPELIST: "productsTypeList",
  },
};

export const classes = {
  app: {
    modal: "hmc-app__modal",
  },
  page: "hmc-page",
  question: "question",
  header: {
    element: "hmc-header",
    restart: "hmc-app__navigation__restart",
    restartTop: "hmc-app__restart",
    title: "hmc-header__title",
  },
  navigation: {
    title: "hmc-navigation__title",
    page: "hmc-navigation__page",
    active: "active",
    visited: "visited",
    app: "hmc-app__navigation",
  },
  slide: {
    active: "active",
    selected: "selected",
    content: "slide-content",
    text: "slide-content--text",
  },
  btn: {
    disabled: "disabled",
    end: "end",
  },
  registration: {
    element: "hmc-app__registration-form",
    image: "hmc-app__registration-form__image",
    wrapper: "hmc-app__registration-form__wrapper",
    title: "hmc-app__registration-form__content--title",
    body: "hmc-app__registration-form__content--body",
    form: "hmc-app__registration-form__content__form",
    field: "hmc-app__registration-form__content__form--field",
    input: "hmc-app__registration-form__content__form--input",
    thankyou: {
      wrapper: "hmc-app__registration-form__wrapper_thankyou",
      title: "hmc-app__registration-form__content__thankyou--title",
      body: "hmc-app__registration-form__content__thankyou--body",
      copy: "hmc-app__registration-form__content__thankyou--copy",
      note: "hmc-app__registration-form__content__thankyou--note",
    },
  },
  spinner: {
    element: "dln-loading-spinner",
    visible: "dln-loading-spinner--visible",
  },
  results: {
    page: "results",
  },
};

export const attributes = {
  data: {
    QUESTION: "data-question",
    QUESTION_NAME: "data-qname",
    ANSWER: "data-answer",
    MINSELECTEDCHOICES: "data-minselectedchoices",
    MAXSELECTEDCHOICES: "data-maxselectedchoices",
    PAGE: "data-page",
  },
};

export const iconFA = {
  icon: {
    text: {
      position: {
        after: "after",
        before: "before",
      },
      space: {
        single: " ",
        double: "&nbsp;&nbsp;",
        empty: "",
      },
    },
  },
};

export const time = {
  START: "time",
  END: "timeEnd",
  _: function (name = false, type = this.START) {
    if (name !== false) console[type](name);
  },
};

export const tagging = {
  event: {
    name: "help_me_choose",
    category: "engagement",
    action: {
      step: "help_me_choose-step",
      end: "help_me_choose-end",
      productClick: "help_me_choose-product_click",
      addToCart: "help_me_choose-addToCart",
    },
  },
};

export let _hmcObject = {};
